import PropTypes from 'prop-types'
import Type from 'components/Type'
import Box from '@mui/material/Box'

const CircleButton = ({
  active,
  inactive,
  children,
  ...props
}) =>
  <Box
    className={active && 'active'}
    sx={theme => ({
      display: 'inline-grid',
      placeItems: 'center',
      placeContent: 'center',
      width: '100px',
      height: '100px',
      borderRadius: '150px',
      borderStyle: 'solid',
      borderWidth: theme.globals.borderWidth.thick,
      borderColor: inactive ? theme.palette.background.neutral_300.main : theme.palette.primary.main,
      color: inactive ? theme.palette.background.neutral_300.main : theme.palette.primary.main,
      // borderColor: theme.palette.border.main,
      // color: theme.palette.text.neutral_300,
      cursor: 'pointer',
      transition: theme.internalMixins.setTransition(['color', 'background-color']),
      '&:hover, &.active': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.text,
        // backgroundColor: theme.palette.background.neutral_300.main,
        // color: theme.palette.background.neutral_300.text,
      },
    })}
    {...props}
  >
    <Type
      variant="dataLarge"
    >
      {children}
    </Type>
  </Box>

CircleButton.propTypes = {
  inactive: PropTypes.bool,
  active: PropTypes.bool,
}

CircleButton.defaultProps = {
  inactive: false,
  active: false,
}

export default CircleButton